export enum ChangeRequestWorkflowAction {
    Submitted = 'Submitted',
    Pending = 'Pending',
    Acknowledged = 'Acknowledged',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Escalated = 'Escalated',
    Delegated = 'Delegated',
    DelegationRevoked = 'DelegationRevoked',
    Reassigned = 'Reassigned',
}

export const ChangeRequestWorkflowActionLabels: Record<ChangeRequestWorkflowAction | string, string> = {
    Submitted: 'Submitted',
    Pending: 'Set to Pending',
    Acknowledged: 'Acknowledged (below DOA limit)',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Escalated: 'Escalated (SLA elapsed)',
    Delegated: 'Delegated',
    DelegationRevoked: 'Delegation Revoked',
    Reassigned: 'Reassigned',
};
